import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { ArrowRight, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const QUESTIONS = [
  { key: "self", label: "¿Cómo me valoro como persona?", placeholder: "Escribe libremente sobre tu autopercepción..." },
  { key: "safety", label: "¿Me siento seguro/a en general?", placeholder: "Reflexiona sobre tu sensación de seguridad..." },
  { key: "world", label: "¿Cómo veo el mundo?", placeholder: "Escribe tu visión del mundo y los demás..." },
];

export default function BeliefListsStep({ sessionNumber, onDone }) {
  const [answers, setAnswers] = useState({});
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (Object.values(answers).filter(v => v?.trim()).length < 1) {
      toast.error("Responde al menos una pregunta.");
      return;
    }
    setSaving(true);
    try {
      await api.post("/progress", { session_number: sessionNumber, step: "belief-lists", completed: true, payload: answers });
      toast.success("Guardado");
      onDone(answers);
    } catch {
      toast.error("No pudimos guardar tus respuestas.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <p className="text-[var(--ha-muted)] leading-relaxed max-w-2xl">Explora tus creencias respondiendo con sinceridad. No hay respuestas correctas.</p>
      <div className="mt-6 space-y-4">
        {QUESTIONS.map(q => (
          <Card key={q.key} className="rounded-2xl border-[var(--ha-border)] bg-white">
            <CardContent className="p-6">
              <div className="flex items-center gap-2 mb-3">
                <Sparkles className="w-4 h-4 text-[var(--ha-secondary)]" strokeWidth={1.75} />
                <p className="font-semibold text-[var(--ha-text)]">{q.label}</p>
              </div>
              <Textarea data-testid={`bl-${q.key}`} value={answers[q.key] || ""} onChange={(e) => setAnswers({ ...answers, [q.key]: e.target.value })} placeholder={q.placeholder} className="rounded-xl border-[var(--ha-border)]" />
            </CardContent>
          </Card>
        ))}
      </div>
      <div className="mt-8 flex justify-end">
        <Button data-testid="bl-continue" onClick={save} disabled={saving} className="rounded-full bg-[var(--ha-primary)] hover:bg-[var(--ha-primary-hover)] text-white h-11 px-6">
          Continuar <ArrowRight className="w-4 h-4 ml-1.5" strokeWidth={1.75} />
        </Button>
      </div>
    </div>
  );
}
